import { DependencyList, EffectCallback, useEffect } from 'react';

export function use_effect(effect: EffectCallback, deps: DependencyList = [], name: string = '', enable_debugger_breakpoint: boolean = false) {
  useEffect(effect, deps);
}
